import { apiClient } from './client';
import type { Word } from '../types';
import { cacheWords, getCachedWords } from '../store/offlineStore';

export interface Sheet {
  sheet: string;
  count: number;
}

export async function fetchWords(page = 1, limit = 1000): Promise<Word[]> {
  try {
    const { data } = await apiClient.get<Word[]>('/words', {
      params: { page, limit },
    });
    await cacheWords(data);
    return data;
  } catch {
    const cached = await getCachedWords();
    if (cached.length > 0) return cached;
    throw new Error('Failed to fetch words and no cache available');
  }
}

export async function fetchWordById(id: string): Promise<Word> {
  const { data } = await apiClient.get<Word>(`/words/${id}`);
  return data;
}

export async function fetchSheets(): Promise<Sheet[]> {
  const { data } = await apiClient.get<Sheet[]>('/words/sheets');
  return data;
}
